var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getCustomerMainPerson } from './customerDetails';
import { getTaxDetailsFromPerson } from './customerTax';
import { getCustomerReferenceAccount } from './referenceAccount';
export const getMainCustomer = ({ customer, }) => {
    var _a, _b;
    const mainPerson = getCustomerMainPerson(customer);
    if (!customer || !mainPerson)
        return;
    const { _embedded } = customer, customerProps = __rest(customer, ["_embedded"]);
    return Object.assign(Object.assign({}, customerProps), { referenceAccount: getCustomerReferenceAccount(customer), taxDetails: getTaxDetailsFromPerson(mainPerson) || {}, firstName: mainPerson.firstName || '', lastName: mainPerson.lastName || '', email: ((_a = mainPerson.contactDetails) === null || _a === void 0 ? void 0 : _a.email) || '', phoneNumber: ((_b = mainPerson.contactDetails) === null || _b === void 0 ? void 0 : _b.phoneNumber) || '' });
};
//# sourceMappingURL=mainCustomer.js.map